import setCookie from 'utils/cookie/setCookie';

export default function deleteCookie(cname, domain = window.location.hostname, path = '/') {
  if (!process.browser) {
    return;
  }

  setCookie(cname, '', -1, domain, path);
}
